import { isEmpty, toString } from 'lodash-es'
import { DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import { FileIcon } from '@/Atomic/Molecules/FileIcon'
import { getActivityTypeIcon } from '@/Components/Activity/getActivityTypeIcon'
import { CellRendererParams } from '@/Components/EntityTable/types'
import { SchemaAttributes } from '@/Data/types'
import { getAutomationsLink, isAutomationsItem } from '@/utils/automationsUtils'
import { getDataItemTitle } from '@/utils/dataClassMap'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

import './ActivityOverviewCell.scss'

const subTypeTitleForActivity = (
  schema: DataItem,
  subTypeValue: string,
): string => {
  const schemaAttributes = getLocalizedSchemaAttributes(
    schema.get('attributes') as SchemaAttributes,
  )
  const subTypes = schemaAttributes?.['subType']?.enumValues
  if (!subTypes) return subTypeValue
  const match = subTypes.find(({ value }) => value === subTypeValue)
  return match?.title ?? subTypeValue
}

export const ActivityOverviewCell = ({
  dataItem,
  schema,
}: CellRendererParams) => {
  const typeValue = (dataItem.get('type') as string) || ''
  const subTypeValue = (dataItem.get('subType') as string) || ''
  const subTypeTitle = subTypeTitleForActivity(schema, subTypeValue)
  const rawTitle = (getDataItemTitle(dataItem) as string) || ''
  const title = isEmpty(toString(rawTitle)) ? '-' : rawTitle

  const automationsItem = isAutomationsItem(dataItem)
  const automationsLink = getAutomationsLink(dataItem)

  return (
    <div className="activity-overview-cell">
      <FileIcon
        icon={getActivityTypeIcon(typeValue)}
        type="generic"
        size="sm"
      />
      <div className="activity-overview-text">
        <StringText
          className="activity-type"
          variant="subtitle"
          value={subTypeTitle}
        />
        {automationsItem ? (
          <StringText
            className="activity-title underline-on-hover-only"
            variant="link"
            value={title}
            href={automationsLink}
            onClick={(e) => {
              e.stopPropagation()
            }}
          />
        ) : (
          <StringText
            className="activity-title underline-on-hover-only"
            variant="link"
            value={title}
            dataItem={dataItem}
          />
        )}
      </div>
    </div>
  )
}
